import React, { useState } from 'react';

import { AbaFilterButtons, AbaFilterContent } from '../../../../components/develop-nilton-components/AbaFiltro';
import { QueixasAnual } from './QueixasAnual';
import { QueixasTrimestral } from './QueixasTrimestral';

export function Queixas({ tabType }:{tabType:number}) {
  const [tab, setTab] = useState(1);
  return (
    <div className="mt-3">
      <AbaFilterButtons
        useStateTab={[tab, setTab]}
        buttons={["Anual", "Trimestral"]}
      />
      <AbaFilterContent
        tab={tab}
        components={[
          <QueixasAnual tab={tab} tabType={tabType} />,
          <QueixasTrimestral tab={tab} tabType={tabType} />,
        ]}
      />
    </div>
  );
}
